import ListPageLayout from "../../components/layout/ListPageLayout";
import filesApi from "../../services/filesApi";
import foldersApi from "../../services/foldersApi";
import {useParams} from "react-router";
import { useState, useEffect } from "react";
import foldersDocsApi from "../../services/foldersDocsApi";
import filesDocsApi from "../../services/filesDocsApi";

export default function FilesDocs() {
    const { folderId } = useParams();
    const [folderName, setFolderName] = useState("...");

    useEffect(() => {
        async function fetchFolderName() {
            try {
                const response = await foldersDocsApi.one(String(folderId));
                setFolderName(response.data.name);
            } catch (error) {
                console.error("Erro ao buscar o nome da pasta:", error);
                setFolderName("Pasta não encontrada");
            }
        }
        
        if (folderId) {
            fetchFolderName();
        }
    }, [folderId]);
    
    return (
        <ListPageLayout
            title={`Cadastro de Arquivos - ${folderName}`}
            urlReturn={'/pastas-documentos'}
            urlCreate={`/pastas-documentos/${folderId}/arquivos/formulario`}
            queries={{
                ['relations']: 'userCreate',
                ['where']: `id_folder_docs,=,${folderId}`
            }}
            collunSearch={'description'}
            permission={'filesDocs.edit'}
            table={
                {
                    loader: filesDocsApi.all,
                    columns: [
                        { label: "Descrição", index: "description", type: 'string'},
                        /*{ label: "Tipo do Documento", index: "type.description", type: 'string'},*/
                        { label: "Usuário", index: "user_create.name", type: 'string'},
                        { label: "Data", index: "created_at", type: 'dateT'},
                    ]
                }
            }
        />
    )
}
